var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.387,
    height: 34.387,
    viewBox: "0 0 34.387 34.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_document-text",
    "data-name": "vuesax/outline/document-text",
    transform: "translate(-492 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(492 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7,30.8H8.238C3.009,30.8,0,27.8,0,22.566V8.238C0,3.009,3.009,0,8.238,0H19.7c5.23,0,8.238,3.009,8.238,8.238V22.566C27.939,27.8,24.93,30.8,19.7,30.8ZM8.238,2.149c-4.1,0-6.089,1.992-6.089,6.089V22.566c0,4.1,1.992,6.089,6.089,6.089H19.7c4.1,0,6.089-1.992,6.089-6.089V8.238c0-4.1-1.992-6.089-6.089-6.089Z",
    transform: "translate(3.224 1.791)",
    fill: "#1899d7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.806,7.88H3.94A3.938,3.938,0,0,1,0,3.94V1.075A1.082,1.082,0,0,1,1.075,0,1.082,1.082,0,0,1,2.149,1.075V3.94A1.792,1.792,0,0,0,3.94,5.731H6.806a1.075,1.075,0,0,1,0,2.149Z",
    transform: "translate(19.701 5.373)",
    fill: "#1899d7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.806,2.149H1.075A1.082,1.082,0,0,1,0,1.075,1.082,1.082,0,0,1,1.075,0H6.806A1.082,1.082,0,0,1,7.88,1.075,1.082,1.082,0,0,1,6.806,2.149Z",
    transform: "translate(10.388 17.552)",
    fill: "#1899d7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M12.537,2.149H1.075A1.082,1.082,0,0,1,0,1.075,1.082,1.082,0,0,1,1.075,0H12.537a1.082,1.082,0,0,1,1.075,1.075A1.082,1.082,0,0,1,12.537,2.149Z",
    transform: "translate(10.388 23.283)",
    fill: "#1899d7",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H34.387V34.387H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H34.387V34.387H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin11);
export default __webpack_public_path__ + "static/media/spin11.af055c38b24c664c55dda0ea4a4392ea.svg";
export { ForwardRef as ReactComponent };